import { apiRequest } from './apiClient';
export const fetchBanners = async () => (await apiRequest('/career-banners')).data;
export const saveBanner = async (image, alt) => {
  const body = new FormData();
  body.append('image', image);
  body.append('alt', alt);
  return (await apiRequest('/career-banners', { method: 'PUT', body })).data;
};
export const removeBanner = () => apiRequest('/career-banners', { method: 'DELETE' });
